import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';


interface IPageAc0028 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    formulaireApo: IFormulaire;
    aosMultiOccurrenceOptions: IMultiOccurrenceOptions;
    docMultiOccurrenceOptions: IMultiOccurrenceOptions;
    docMultiOccurrence: IMultiOccurrence;
    adoMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Ac0028Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    Menu: IMenuClass,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    MenuItemAction: IMenuItemActionClass,
    ac0010Route: IRoute,
    cp2010Route: IRoute
) {
    const vm: IPageAc0028 = this;

    vm.$onInit = $onInit;
    vm.valeursEcran = ecranDetails.valeurs;
    function $onInit() {
        vm.monoOccurrenceOptions = {
            infosMonetaires: {
                blocs: ['APO'],
                largeurTexte: 150,
                donnees:
                    [
                        { nom: 'apomnt', libelle: 'MNTBASE' },
                        { nom: 'apomntbdg', libelle: 'MNTPROL', lastOfGroup: true },
                        { nom: 'docref', libelle: 'DOCREF' },
                        { nom: 'mntdec', libelle: 'MNTDEC' },
                        { nom: 'mntpai', libelle: 'MNTPAI', lastOfGroup: true },
                        { nom: 'fouinv', libelle: 'FOUINV' },
                        { nom: 'fouao', libelle: 'FOUAO' },
                        { nom: 'soumis', libelle: 'SOUMIS' }
                    ]
            },

            fonctions: {
                supprime: false,
                boutonDupliquer: false
            }
        };


        vm.formulaireApo = new Formulaire('LBL_BLC_APO', [
            new FormulaireItem('aponumdoc', { largeur: 30 }),
            new FormulaireItem('apoindreg10', { largeur: 30 }),
            new FormulaireItemSautDeLigne(),

            new FormulaireItem('tydcleint', { required: true, largeur: 30, readonly: (data: any) => data.$id }),
            new FormulaireItem('vaeapoon', { default: 2, required: true, largeur: 30 }),
            new FormulaireItemSautDeLigne(),

            new FormulaireItem('aponumref', { required: true, largeur: 30 }),
            new FormulaireItem('aponumseao', { largeur: 15 }),
            new FormulaireItemSautDeLigne(),

            new FormulaireItem('apodatpub', { largeur: 30 }),
            new FormulaireItem('apodatfer', { largeur: 30 }),
            new FormulaireItem('apoflgpij', { largeur: 20 }),
            new FormulaireItemSautDeLigne(),

            new FormulaireItem('apodatred', { largeur: 30 }),
            new FormulaireItem('apodatfin', { largeur: 30 }),
            new FormulaireItemSautDeLigne(),

            new FormulaireItem('ncocleint', { largeur: 60 }),
            new FormulaireItem('apomnt', { largeur: 30 }),
            new FormulaireItemSautDeLigne(),

            new FormulaireItem('tnecleint', { largeur: 30 }),
            new FormulaireItem('vecapomodadj', { largeur: 30 }),
            new FormulaireItem('apomntbdg', { largeur: 30 }),
            new FormulaireItemSautDeLigne(),

            new FormulaireItem('intcleintreq', { required: true, largeur: 45 }),
            new FormulaireItem('intcleintach', { required: true, largeur: 30 }),
            new FormulaireItemSautDeLigne(),

            new FormulaireItem('apodsc', { required: true, largeur: 60, enableCount: true }),
            new FormulaireItem('etdcleint', { hidden: true }),

        ], { largeurDefaut: 80 })
    }

    vm.aosMultiOccurrenceOptions = {
        bloc: 'aos',  // Fournisseurs
        fonctions: {
            boutonDupliquer: false,
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            { nom: 'refcod', largeur: 120 },
            { nom: 'refnom', largeur: 150 },
            { nom: 'radcod', largeur: 120 },
            { nom: 'adrdsc', largeur: 120 },
            { nom: 'radnom', largeur: 150 },
            { nom: 'vecdscinv', largeur: 120 },
            { nom: 'vecdscrep', largeur: 120 },
            { nom: 'aoscom', largeur: 120 },
            { nom: 'aosindadj', largeur: 120}
        ],

        formulaire: new Formulaire('LBL_BLC_AOS', [
            new FormulaireItem('refcleint', {
                largeur: 33
            }),
            new FormulaireItem('radcleint', {
                largeur: 33
            }),
            new FormulaireItem('vecaosinv', {
                largeur: 33
            }),
            new FormulaireItem('vecaosrep', {
                largeur: 33
            }),
            new FormulaireItem('aosindadj', {
                largeur: 33
            }),
            new FormulaireItem('aoscom', {
                largeur: 33
            })
        ])
    };
    vm.docMultiOccurrenceOptions = {
        bloc: 'doc', // Document référé
        navigatePage: (rowData: any) => getForageItem(rowData),
        navigateParams: (rowData: any) => getParamItem(rowData),
        fonctions: {
            boutonDupliquer: false,
            nouveau: vm.valeursEcran.ajouter_doc,
            edition: false,
            supprime: true,
            rechercheCollapsable: false
        },
        actionsNouveaux: new Menu([new MenuItemAction(
            'LBL_BTN_AJT_DOC',
            'BOUAJTDOC',
            () => ({}),
            {
                icon: 'add_circle',
                fonction: 'BOUAJTDOC',
                formulaireConfirmationAction: {
                    lblTitre: 'LBL_BTN_AJT_DOC',
                    lblConfirm: 'G_LBL_BTN_APPLIQUER',
                    largeurFormulaire: 30,
                    formulaire: new Formulaire([
                        new FormulaireItem('doccleintajtdoc', { required: true, maxlength: 300 }),
                        new FormulaireItem('cleintref', { hidden: true }),
                        new FormulaireItem('stamnetab', { hidden: true }),
                    ], {
                        largeurDefaut: 100
                    })
                },
                successAction: () => {
                    vm.docMultiOccurrence.fetchDataList();
                },
                disabled: !vm.valeursEcran.ajouter_doc
            },


        ),]),
        actionsRangeeDroite: new Menu([
            new MenuItemAction(
                'LBL_BTN_SUP_DOC',
                'BOUSUPDOC',
                (rowData: any) => (
                    {
                        docaffcleint01: rowData.docaffcleint01,
                        tydmnedoc: rowData.tydmnedoc
                    }),
                {
                    icon: 'delete',
                    fonction: 'BOUSUPDOC',
                    successAction: () => {
                        vm.docMultiOccurrence.fetchDataList();
                    },
                }
            )
        ]),
        colonnesVisibles: [
            { nom: 'docaffnumdoc01', largeur: 130 },
            { nom: 'docaffsysboncmd01', largeur: 130 },
            { nom: 'tydcod', largeur: 130 },
            { nom: 'tyddsc', largeur: 140 },
            { nom: 'docaffmnt01_atcan', largeur: 190 },
            { nom: 'docaffmnt01', largeur: 130 },
            { nom: 'refcod', largeur: 130 },
            { nom: 'refnom', largeur: 130 },
            { nom: 'docaffdsc01', largeur: 150 }
        ],

        formulaire: new Formulaire('LBL_BLC_ADO', [
            new FormulaireItem('doccleintajtdoc', { required: true, maxlength: 300 })
        ], { largeurDefaut: 30 }),
        colonnesCachees: ['ecrcod', 'docaffcleint01', 'doccleintref', 'tydmnedoc']
    };

    vm.adoMultiOccurrenceOptions = {
        bloc: 'ado', // Déclatation SEAO
        fonctions: {
            boutonDupliquer: false,
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            { nom: 'adodat', largeur: 30 },
            { nom: 'tdocod', largeur: 30 },
            { nom: 'tdodsc', largeur: 30 },
            { nom: 'adomnt', largeur: 30 },
            { nom: 'adoconfirmation', largeur: 60 },
            { nom: 'adoflgann', largeur: 30 }
        ],

        formulaire: new Formulaire('LBL_BLC_ADO', [
            new FormulaireItem('adodat'),
            new FormulaireItem('tdocleint'),
            new FormulaireItem('adomnt', {
                required: true
            }),
            new FormulaireItem('adoconfirmation'),
            new FormulaireItem('adoflgann')
        ], { largeurDefaut: 30 })
    };

    // Plaquette Autres détails
    vm.formulaireAutresDetails = new Formulaire('LBL_BLC_AUT', [
        new FormulaireItem('nibcleint'),
        new FormulaireItem('vecapoouvpub'),
        new FormulaireItem('apodatdeb'),
        new FormulaireItem('aponumrescd', { readonly: true }),
        new FormulaireItem('aponumresca', { readonly: true }),
    ], { largeurDefaut: 50 });

    function getForageItem(rowData: any): string {
        if (rowData.ecrcod === 'CP0013-00') {
            return cp2010Route.NAME;
        } else {
            return ac0010Route.NAME;
        }
    }
    function getParamItem(rowData: any) {
        if (rowData.ecrcod === 'CP0013-00') {
            return { id: rowData.docaffcleint01 };
        } else {
            return { id: rowData.doccleintref };
        }
    }
}
